module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/inbox-87ad1da39e17e19fb1f7da89a816b3e7.svg";